import React, { FC } from "react";
import { List, ListItemButton, ListItemText } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { NavigationConfig } from "./types/navigationConfigType";

interface NavigationItemProps {
  navConfig: NavigationConfig;
  closeMenu?: () => void;
}

const NavigationItem: FC<NavigationItemProps> = (props) => {
  const { navConfig, closeMenu } = props;
  const navigate = useNavigate();

  const handleClick = () => {
    if (navConfig.isExternal) {
      window.location.assign(navConfig.path || "");
    } else {
      navigate(navConfig.path || "");
    }
    if (closeMenu) {
      closeMenu();
    }
  };

  return (
    <List sx={{ borderBottom: "1px solid var(--color-border, #f6f6f6)" }}>
      <ListItemButton
        className="topNavigationMenuContent"
        onClick={handleClick}
        component={motion.div}
        whileHover={{ x: 2 }}
        whileTap={{ scale: 0.98 }}
        sx={{ borderRadius: "var(--radius-sm)" }}
      >
        <ListItemText primary={navConfig.title} />
      </ListItemButton>
    </List>
  );
};

export default NavigationItem;
